module.exports = __webpack_public_path__ + "static/media/换热_03.d6d85b99.png";